module.exports = __webpack_public_path__ + "static/media/plumber-_1_ (1).c64b2983.svg";